import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { redirectLogin } from '../utils/oa'
import { getToken } from '../utils/user'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/exchange',
    name: 'exchange',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "exchange" */'../views/Exchange.vue')
    },
    meta: { requireLogin: true }
  },
  {
    path: '/user',
    name: 'user',
    component: function () {
      return import(/* webpackChunkName: "user" */'../views/User.vue')
    },
    meta: { requireLogin: true }
  },
  {
    path: '/rule',
    name: 'rule',
    component: function () {
      return import('../views/Rule.vue')
    }
  },
  {
    path: '/repair',
    name: 'repair',
    component: function () {
      return import('../views/Repair.vue')
    }
  },
  {
    path: '/applyCredit',
    name: 'applyCredit',
    component: function () {
      return import('../views/ApplyCredit.vue')
    },
    meta: { requireLogin: true }
  },
  {
    path: '/audit',
    name: 'audit',
    component: function () {
      return import('../views/ApplyAuditQuery.vue')
    },
    meta: { requireLogin: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  let store = router.app.$options.store
  if (to.query && to.query.sid) {
    await store.dispatch('init')
    await store.dispatch('graphaqlAuditInfo')
    next({
      path: to.fullPath.replace(/\??&?sid=[^&]+&lang=cn/, ''),
      replace: true
    })
    return
  } else {
    const token = getToken()
    if ((to.meta.requireLogin || token) && !store.state.email) {
      try {
        await store.dispatch('init')
      } catch (err) {
        redirectLogin(`${window.location.origin}${to.fullPath}`)
        return
      }
    }
  }
  await store.dispatch('graphaqlAuditInfo')
  next()
})

export default router
